import {
  DatabaseService,
  PurchaseOrder,
  PurchaseOrderData,
  PurchaseOrderRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getPurchaseOrderRepository(
  databaseService: DatabaseService,
): PurchaseOrderRepository {
  return getGenericRepository<PurchaseOrder, PurchaseOrderData>(
    () => DatabaseCollection.PURCHASE_ORDERS,
    databaseService,
  );
}
